import React from 'react';

import { Switch, Route, Redirect } from 'react-router-dom';

import AdminLanding from 'modules/partial/containers/AdminLanding';
import VendorLanding from 'modules/partial/containers/VendorLanding';
import PartnerLanding from 'modules/partial/containers/PartnerLanding';
import VendorSignUp from 'modules/partial/containers/VendorSignUp';
import LocationLanding from 'modules/partial/containers/LocationLanding';
import ForgotPasswordLanding from 'modules/partial/containers/ForgotPasswordLanding';
import RegisterLoader from 'modules/partial/containers/RegisterLoader';
import ResetPassword from 'modules/partial/containers/ResetPassword';
import PasswordExpiredLanding from 'modules/partial/containers/PasswordExpiredLanding';
import MultiFactorAuthLanding from 'modules/partial/containers/MultiFactorAuthLanding';
import ActivateAccount from 'modules/partial/forms/ActivateAccount';

import Rider from './modules/rider';
import InhouseOrdering from './modules/inhouse-ordering';

function Public() {
  return (
    <Switch>
      <Route path="/r" component={Rider} />
      <Route path="/c/:key" component={InhouseOrdering} />
      <Route path="/register-redirect" component={RegisterLoader} />
      <Route path="/reset-password" component={ResetPassword} />
      <Route path="/merchant-login" component={VendorLanding} />
      <Route path="/partner-login" component={PartnerLanding} />
      <Route path="/password-expired" component={PasswordExpiredLanding} />
      <Route path="/multi-factor-auth" component={MultiFactorAuthLanding} />
      <Route path="/merchant-signup" component={VendorSignUp} />
      <Route path="/activate-account" component={ActivateAccount} />
      <Route path="/location-login" component={LocationLanding} />
      <Route path="/forgot-password" component={ForgotPasswordLanding} />
      <Route path="/login" component={AdminLanding} />
      <Redirect to="/merchant-login" />
    </Switch>
  );
}
Public.defaultProps = {};

Public.propTypes = {};

export default Public;
